import styled, { css } from 'styled-components'

export const TitleWrapper = styled.div`
  ${({ theme }) => css`
    display: flex;
    align-items: center;
    gap: 0.5rem;

    .imageWrapper img {
      border-radius: 4px;
      box-shadow: 0px 24px 48px 0px #00000029;
      transition: filter 0.2s ease-in-out;
    }

    tr:hover & .imageWrapper img {
      filter: brightness(0.7);
    }

    .mainInfo {
      line-height: 1;
      min-width: 200px;

      .title {
        margin-bottom: ${theme.spacings.tiny};
        display: -webkit-box;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
        overflow: hidden;
        color: ${theme.colors.primary};
        font-size: ${theme.font.sizes.xsmall};
        overflow-wrap: anywhere;
      }

      .description {
        font-size: ${theme.font.sizes.xsmall};
        display: inline-flex;

        > div {
          margin-bottom: 0;
        }
      }
    }
  `}
`
